import { render, staticRenderFns } from "./DownloadQR.vue?vue&type=template&id=34dcb9b2&"
import script from "./DownloadQR.vue?vue&type=script&lang=js&"
export * from "./DownloadQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports